import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorProjectTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderProjectTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelTextProjectTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	error: {
		id: 'project-picker.error',
		defaultMessage: "We couldn't retrieve projects",
		description:
			'Label for the project picker error. It is shown in case of error fetching projects from the server and displayed inside inline dialog which places automatically above/below or next to the picker',
	},
	placeholder: {
		id: 'project-picker.placeholder',
		defaultMessage: 'Project',
		description:
			'Placeholder for the project picker. Displayed in case it does not have selected value',
	},
	labelText: {
		id: 'project-picker.label-text',
		defaultMessage: 'Project',
		description: 'Label name of project field for screen reader users',
	},
	errorProjectTermRefresh: {
		id: 'project-picker.error-project-term-refresh',
		defaultMessage: "We couldn't retrieve spaces",
		description:
			'Label for the project picker error. It is shown in case of error fetching projects from the server and displayed inside inline dialog which places automatically above/below or next to the picker',
	},
	placeholderProjectTermRefresh: {
		id: 'project-picker.placeholder-project-term-refresh',
		defaultMessage: 'Space',
		description:
			'Placeholder for the project picker. Displayed in case it does not have selected value',
	},
	labelTextProjectTermRefresh: {
		id: 'project-picker.label-text-project-term-refresh',
		defaultMessage: 'Space',
		description: 'Label name of project field for screen reader users',
	},
});
export default messages;
